import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoaderProvider } from './context/LoaderContext';
import { NotesProvider } from './context/NotesContext';
import AppRoutes from './routes/Routes';
import AuthDebugPanel from './auth/AuthDebugPanel'; // Dev-only debug panel
import TokenInitializer from './auth/TokenInitializer'; // Pre-acquire tokens

function App() {
  return (
    <Router>
      <LoaderProvider>
        <NotesProvider>
          <TokenInitializer />
          <AppRoutes />
          <AuthDebugPanel /> {/* Shows auth state in dev mode */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </NotesProvider>
      </LoaderProvider>
    </Router>
  );
}

export default App;
